import { render } from "./Background.vue?vue&type=template&id=0da89377&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"

import "./Background.vue?vue&type=style&index=0&id=0da89377&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da89377"]])

export default __exports__